import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/vacation-budget-calculator',
  component: () => import('../../routes/VacationBudgetCalculator.svelte'),
  card: {
    id: 'vacation-budget-calculator',
    title: 'Vacation Budget',
    description: 'Plan your perfect trip by estimating costs for flights, lodging, food, activities, and more.',
    icon: 'flight',
    iconBgClass: 'bg-sky-50',
    iconTextClass: 'text-sky-600',
    href: '/vacation-budget-calculator',
    category: 'Travel & Distance',
  },
  seo: {
    title: 'Vacation Budget Calculator – Plan Your Trip Costs',
    description: 'Free vacation budget calculator to estimate your trip costs. Calculate flights, lodging, food, activities, and more. Plan the perfect getaway within your budget.',
  },
};

export default meta;
